import { services } from "@/mocks/services";

const serviceToCategory: Record<string, string> = {
  interior: "Interior",
  exterior: "Exterior",
  residential: "All",
  commercial: "Commercial",
  repairs: "Repair",
  pressure: "Pressure Washing",
};

export default function ServicesSection() {
  return (
    <section
      id="services"
      className="py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-foreground-950"
    >
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-flex items-center border border-background-300/30 rounded-full px-5 py-1.5 text-xs font-medium tracking-wider uppercase text-background-300 mb-6">
            Our Services
          </div>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-medium text-background-50 mb-4">
            What We Offer
          </h2>
          <p className="text-background-300 max-w-xl mx-auto">
            Comprehensive painting and surface preparation services tailored to
            your needs.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {services.map((service) => (
            <a
              key={service.id}
              href={`/portfolio?category=${serviceToCategory[service.id] || "All"}`}
              className="group relative rounded-2xl overflow-hidden aspect-square cursor-pointer"
            >
              <img
                src={service.image}
                alt={service.title}
                className="absolute inset-0 w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
              <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-6">
                <h3 className="font-heading text-xl md:text-2xl font-medium text-background-50 mb-1">
                  {service.title}
                </h3>
                <p className="text-sm text-background-300/90 mb-3">
                  {service.subtitle}
                </p>
                <p className="text-xs text-background-300/70 max-w-[220px] opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  {service.description}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}